import { useContext, useEffect, useRef } from 'react';
import { createContext } from 'react';

const scrollUp = (e: HTMLElement, behavior: 'smooth' | 'auto') =>
  e.scroll({ top: 0, behavior });
const scrollIntoView = (
  e: HTMLElement,
  behavior: 'smooth' | 'auto',
  block: ScrollLogicalPosition,
  inline: ScrollLogicalPosition,
) => e.scrollIntoView({ behavior, block, inline });

export const ScrollIntoView = ({
  behavior,
  block = 'start',
  inline = 'nearest',
}: {
  behavior: 'smooth' | 'auto';
  inline?: ScrollLogicalPosition;
  block?: ScrollLogicalPosition;
}) => {
  const elementRef = useRef<HTMLDivElement>(null);
  useEffect(
    () => scrollIntoView(elementRef.current!, behavior, block, inline),
    [],
  );
  return <div ref={elementRef}></div>;
};
const ScrollContext = createContext({
  scrollToTop: () => {},
});
export const useScroller = () => {
  return useContext(ScrollContext);
};

export default function ScrollContainer(props: {
  height?: any;
  children?: any;
  showScrollToTop?: boolean;
  overflow?: 'scroll' | 'auto';
}) {
  const { children, showScrollToTop } = props;
  const overflow = props.overflow ? props.overflow : 'scroll';

  const topRef = useRef<HTMLDivElement>(null);
  const scrollToTop = (behavior: 'smooth' | 'auto' = 'auto') =>
    scrollUp(topRef.current!, behavior);

  return (
    <ScrollContext.Provider value={{ scrollToTop }}>
      <div className="relative h-full">
        <div className={`h-full overflow-y-${overflow}`} ref={topRef}>
          {children}
        </div>

        {showScrollToTop && (
          <button
            onClick={() => scrollToTop('smooth')}
            className="absolute bg-green-light outline-none opacity-90 hover:bg-green hover:ring-1 hover:translate-y-2 hover:ring-offset-2  px-4 py-3 focus:outline-none text-white rounded-full bottom-4 right-4"
          >
            ⇧
          </button>
        )}
      </div>
    </ScrollContext.Provider>
  );
}
